import {defineStore} from 'pinia';
import packageJson from "../../package.json";
import api from "@/api";
import {useUserStore} from "@/stores/user";
import {client} from '@/stores/client.js'

export const useConfigStore = defineStore('config', {
  state: () => ({
    configs: {
      games: {
        boost: null,
        account: null,
        currency: null
      },
      stores: null,
      allGames: [],
    },
    latestVersion: null,
    tags: []
  }),
  getters: {
    getGames(state) {
      return state.configs.games;
    },
    getBoostGames(state) {
      return state.configs.games.boost;
    },
    getAccountGames(state) {
      return state.configs.games.account;
    },
    getCurrencyGames(state) {
      return state.configs.games.currency;
    },
    getAllGames(state) {
      return state.configs.allGames;
    },
    getStores(state) {
      return state.configs.stores
    },
    getGamesByService: (state) => (service) => {
      return state.configs.allGames.filter(game => game['has' + service + 'Service'])
    },
    getServerMap(state) {
      return state.configs.allGames.reduce((acc, {game, servers}) => {
        acc[game] = servers;
        return acc;
      }, {});
    }
  },
  actions: {
    async getConfigs() {
      const userStore = useUserStore()
      const request = {
        "request": 10034,
        "client": client
      };
      try {
        await api.post('', request)
          .then((res) => {
            if (res.status === 200) {
              return res.data
            } else {
              console.log('response is ' + res.status)
            }
          }).then((data) => {
            //console.log('getConfigs', data)
            if (data.response === 100) {
              //this.configs.games = data.games
              this.configs.allGames = data.games
              //console.log(this.configs.allGames)
              this.configs.games.currency = data.games.filter(game => game.hasCurrencyService === true);
              this.configs.games.account = data.games.filter(game => game.hasAccountService === true);
              this.configs.games.boost = data.games.filter(game => game.hasBoostService === true);
              this.configs.stores = data.stores
              this.latestVersion = data.client?.latestVersion ? data.client.latestVersion : null;
              this.tags = data.order.tagsValues
            } else {
              userStore.errorMessage = data.message
              return false
            }
          })
      } catch (error) {
        console.log(error);

        /*if (axios.isAxiosError(error)) {
            if (error.response) {
                console.error('Server responded with status:', error.response.status);
            } else if (error.request) {
                if (error.message === 'Network Error') {
                    console.error('The network is aborted');
                    return "network error"
                }
            }
        } else {
            // Handle non-Axios errors
            console.error('An error occurred:', error.message);
        }*/
      }

    },
    async getAllPermissions() {
      const userStore = useUserStore()
      const request = {
        "request": 10019,
        "client": {
          ...client,
          appName: "Rifen",
        }
      };
      console.log(request)
      try {
        await api.post('', request)
          .then((res) => {
            if (res.status === 200) {
              return res.data
            } else {
              console.log('response is ' + res.status)
            }
          }).then((data) => {
            if (data.response === 100) {
              console.log('getAllPermissions', data)
            } else {
              userStore.errorMessage = data.message
              return false
            }
          })
      } catch (error) {
        console.log(error);

        /*if (axios.isAxiosError(error)) {
            if (error.response) {
                console.error('Server responded with status:', error.response.status);
            } else if (error.request) {
                if (error.message === 'Network Error') {
                    console.error('The network is aborted');
                    return "network error"
                }
            }
        } else {
            // Handle non-Axios errors
            console.error('An error occurred:', error.message);
        }*/
      }

    },
  },
})
